import axios from "axios";
import Cookies from "js-cookie";

//const api_base = "http://localhost:8000/AppOkPrint/";

const api_base = "https://apivrc.tagriffe.ma/AppOkPrint/";

const urlQrCode = "https://okprint.ma/";
//const urlQrCode = "https://okprint.ma/event/";

const Api_Token = axios.create({
  baseURL: api_base,
  // headers: {
  //    'Content-Type': 'application/json',
  //  }
});

function updateAuthToken(token) {
  Api_Token.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

const authToken = Cookies.get("token");
if (authToken !== undefined) {
  updateAuthToken(authToken);
}
export { api_base, updateAuthToken, Api_Token, urlQrCode };

// Public Sentry project configuration. Set dsn to "" to disable reporting.
export const sentryConfig = {
  dsn: "https://2e41adcd671ae10d48885e83cc3836dd@o4510691208790016.ingest.de.sentry.io/4510691401859152",
  environment: "production",
};
